import { ChangeEvent, createRef, useEffect, useState } from "react";
import { Box, MenuItem } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateContrato } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField, ButtonPersonalized } from "src/Pages/components";
import { AutoCompleteAdministradoras } from "src/Pages/components/AutoCompleted/AutoCompleteAdministradoras";
import { AutoCompleteFiliaisGeneric } from "src/Pages/components/AutoCompleted/AutoCompleteFiliais";
import { AutoCompleteModalidade } from "src/Pages/components/AutoCompleted/AutoCompleteModalidade";
import { AutoCompleteOperadora } from "src/Pages/components/AutoCompleted/AutoCompleteOperadora";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";

import { AutoCompleteProdutorActiveCorretor } from "../../../../../components/AutoCompleted/AutoCompleteProdutorActiveCorretor";
import { CardPercentsData } from "../CreateContrato/CardPercentsData/CardPercentsData";
import { UseGetComissoesGrade } from "../CreateContrato/CardPercentsData/Hooks/UseGetComissoesGrade";

export const FormContrato = () => {
  UseGetComissoesGrade();

  const { valuesInputsContrato, setValuesInputsContrato } =
    useContextContrato();

  const [open, setOpen] = useState(false);
  const [view, setView] = useState(true);

  const inputRef = createRef<HTMLInputElement>();
  const handleFocusedID = () => inputRef.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  const handleChange =
    (prop: keyof ICreateContrato) => (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsContrato({
        ...valuesInputsContrato,
        [prop]: event.target.value,
      });
    };

  return (
    <>
      <DividerCore title="Contrato" onClick={() => setView((item) => !item)} />

      <Box sx={{ display: view ? "flex" : "none", flexWrap: "wrap" }}>
        <AppTextField
          variant="outlined"
          inputRef={inputRef}
          label="Data assinatura *"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={valuesInputsContrato.assinatura_data}
          onChange={handleChange("assinatura_data")}
        />

        <AppTextField
          select
          variant="outlined"
          id="tipo_contrato"
          label="Fisica | Juridica"
          sxStyle={{ width: "120px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato?.tipo_contrato}
          onChange={handleChange("tipo_contrato")}
        >
          <MenuItem value="PF">Fisica</MenuItem>
          <MenuItem value="PJ">Juridica</MenuItem>
        </AppTextField>

        <AutoCompleteOperadora label="Operadora *" tamanho="180px" variant="outlined" />

        <AutoCompleteAdministradoras label="Administradora" tamanho="180px" variant="outlined" />

        <AutoCompleteModalidade label="Modalidade *" tamanho="240px" variant="outlined" />

        <AutoCompleteProdutorActiveCorretor
          label="Corretor *"
          tamanho="250px"
          variant="outlined"
        />

        <AppTextField
          label="Proposta *"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          tooltip="Código de proposta deve ser único"
          value={valuesInputsContrato.cod_proposta}
          onChange={handleChange("cod_proposta")}
          variant="outlined"
        />

        <AutoCompleteFiliaisGeneric label="Filial *" tamanho="220px" variant="outlined" />

        <ButtonPersonalized
          title="Ver tabela de Comissão"
          titleToolTip="Tabela de comissionamento"
          variant="outlined"
          onClick={() => setOpen(true)}
        />

        <CardPercentsData open={open} setOpen={setOpen} />
      </Box>
    </>
  );
};
